document.addEventListener("DOMContentLoaded", () => {
  /* FAQ accordion */
  try {
    document.querySelectorAll(".skg-faq-button").forEach(btn => {
      btn.addEventListener("click", () => {
        try {
          const item = btn.closest(".skg-faq-item");
          if (!item) return;
          
          const answer = item.querySelector(".skg-faq-a");
          if (!answer) return;

          const isOpen = item.classList.contains("is-open");
          
          // Close all other items
          document
            .querySelectorAll(".skg-faq-item.is-open")
            .forEach(openItem => {
              if (openItem !== item) {
                openItem.classList.remove("is-open");
                const openAnswer = openItem.querySelector(".skg-faq-a");
                if (openAnswer) {
                  openAnswer.style.maxHeight = "0px";
                  const openBtn = openItem.querySelector(".skg-faq-button");
                  if (openBtn) {
                    openBtn.setAttribute("aria-expanded", "false");
                    const answerEl = openItem.querySelector(".skg-faq-a");
                    if (answerEl) answerEl.setAttribute("aria-hidden", "true");
                  }
                }
              }
            });

          if (!isOpen) {
            item.classList.add("is-open");
            answer.style.maxHeight = answer.scrollHeight + "px";
            btn.setAttribute("aria-expanded", "true");
            answer.setAttribute("aria-hidden", "false");
          } else {
            item.classList.remove("is-open");
            answer.style.maxHeight = "0px";
            btn.setAttribute("aria-expanded", "false");
            answer.setAttribute("aria-hidden", "true");
          }
        } catch (error) {
          console.error("Error toggling FAQ item:", error);
        }
      });
    });
  } catch (error) {
    console.error("Error initializing FAQ accordion:", error);
  }

  /* CART DRAWER LOGIC */

  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  const panel = drawer.querySelector(".skg-cart-drawer-panel");
  const backdrop = drawer.querySelector("[data-cart-backdrop]");
  const itemsContainer = drawer.querySelector("[data-cart-items]");
  const subtotalEl = drawer.querySelector("[data-cart-subtotal]");
  const closeButtons = drawer.querySelectorAll("[data-cart-close]");
  const body = document.documentElement;

  const cartIcon = document.querySelector(".skg-cart-icon");

  function setBodyLocked(lock) {
    if (lock) {
      body.classList.add("skg-no-scroll");
    } else {
      body.classList.remove("skg-no-scroll");
    }
  }

  function openDrawer() {
    drawer.classList.add("is-open");
    setBodyLocked(true);
    fetchAndRenderCart();
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    setBodyLocked(false);
  }

  function updateHeaderCount(count) {
    const icon = document.querySelector(".skg-cart-icon");
    if (!icon) return;

    let badge = icon.querySelector(".skg-cart-count");
    if (!badge && count > 0) {
      badge = document.createElement("span");
      badge.className = "skg-cart-count";
      icon.appendChild(badge);
    }
    if (badge) {
      if (count > 0) {
        badge.textContent = count;
      } else {
        badge.remove();
      }
    }
  }

  async function fetchAndRenderCart() {
    try {
      if (!itemsContainer) {
        console.warn("Cart items container not found");
        return;
      }

      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" }
      });
      
      if (!res.ok) {
        throw new Error(`Cart fetch failed: ${res.status} ${res.statusText}`);
      }
      
      const cart = await res.json();
      
      if (!cart) {
        throw new Error("Invalid cart data received");
      }

      // items
      if (!cart.items || !cart.items.length) {
        itemsContainer.innerHTML =
          '<p style="font-size:0.9rem; opacity:0.8;">Your bag is empty. Switch on your first SkinGlow session.</p>';
      } else {
        const html = cart.items
          .map(item => {
            const img =
              item.image ||
              "https://cdn.shopify.com/s/images/admin/no-image-75.gif"; // fallback

            return `
              <article class="skg-cart-item">
                <div>
                  <img src="${img}" alt="${item.product_title}" loading="lazy">
                </div>
                <div>
                  <div class="skg-cart-item-title">${item.product_title}</div>
                  <div class="skg-cart-item-meta">
                    ${item.variant_title || ""} • Qty ${item.quantity}
                  </div>
                  <div class="skg-cart-item-bottom">
                    <span>${Shopify.formatMoney(
                      item.line_price,
                      themeCartMoneyFormat()
                    )}</span>
                  </div>
                </div>
              </article>
            `;
          })
          .join("");
        itemsContainer.innerHTML = html;
      }

      // subtotal
      if (subtotalEl) {
        subtotalEl.textContent = Shopify.formatMoney(
          cart.items_subtotal_price,
          themeCartMoneyFormat()
        );
      }

      updateHeaderCount(cart.item_count || 0);
    } catch (e) {
      console.error("Cart fetch failed", e);
      if (itemsContainer) {
        itemsContainer.innerHTML = '<p style="font-size:0.9rem; opacity:0.8; color: #ff6b6b;">Unable to load cart. Please refresh the page.</p>';
      }
    }
  }

  // Money format helper, tries to read window.theme.moneyFormat or Shopify config
  function themeCartMoneyFormat() {
    if (window.theme && window.theme.moneyFormat) return window.theme.moneyFormat;
    if (window.Shopify && Shopify.money_format) return Shopify.money_format;
    return "${{amount}}";
  }

  // Intercept add-to-cart forms
  try {
    document.querySelectorAll("form.skg-add-to-cart").forEach(form => {
      form.addEventListener("submit", async event => {
        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"]');
        const originalText = submitButton ? submitButton.textContent : "";
        
        try {
          const formData = new FormData(form);
          const id = formData.get("id");
          const quantity = parseInt(formData.get("quantity") || "1", 10) || 1;

          if (!id) {
            throw new Error("Product variant ID is required");
          }
          
          // Show loading state
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = "Adding...";
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              id,
              quantity
            })
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || `Failed to add to cart: ${response.status}`);
          }

          // Once added, open drawer and refresh
          openDrawer();
        } catch (e) {
          console.error("Add to cart failed", e);
          
          // Show user-friendly error
          const submitButton = form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText || "Add to bag";
            
            // Show temporary error message
            const errorMsg = document.createElement("div");
            errorMsg.style.cssText = "color: #ff6b6b; font-size: 0.85rem; margin-top: 8px; text-align: center;";
            errorMsg.textContent = e.message || "Failed to add item. Please try again.";
            form.appendChild(errorMsg);
            setTimeout(() => errorMsg.remove(), 5000);
          }
          
          // Fallback to standard submit only if it's a network error
          if (e.name === "TypeError" || e.message.includes("fetch")) {
            console.warn("Network error, falling back to standard form submit");
            form.submit();
          }
        }
      });
    });
  } catch (error) {
    console.error("Error initializing add-to-cart forms:", error);
  }

  // Open cart when clicking header icon
  try {
    if (cartIcon) {
      cartIcon.addEventListener("click", e => {
        try {
          e.preventDefault();
          openDrawer();
        } catch (error) {
          console.error("Error opening cart drawer:", error);
        }
      });
    }
  } catch (error) {
    console.error("Error setting up cart icon:", error);
  }

  // Close handlers
  try {
    if (backdrop) {
      backdrop.addEventListener("click", closeDrawer);
    }
    closeButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        try {
          e.preventDefault();
          closeDrawer();
        } catch (error) {
          console.error("Error closing cart drawer:", error);
        }
      });
    });
  } catch (error) {
    console.error("Error setting up close handlers:", error);
  }

  // ESC key to close
  try {
    document.addEventListener("keydown", e => {
      if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) {
        try {
          closeDrawer();
        } catch (error) {
          console.error("Error closing drawer with ESC:", error);
        }
      }
    });
  } catch (error) {
    console.error("Error setting up ESC key handler:", error);
  }
});

